<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { startIdleWatch } from '@/utils/idle'

export default {
  name: 'App',
  created() {
    startIdleWatch()
  }
}
</script>

<style>
:root {
  --primary-color: #409EFF;
  --primary-light: #66b1ff;
  --primary-dark: #3a8ee6;
  --success-color: #67C23A;
  --warning-color: #E6A23C;
  --danger-color: #F56C6C;
  --info-color: #909399;
  --text-primary: #303133;
  --text-regular: #606266;
  --text-secondary: #909399;
  --text-placeholder: #C0C4CC;
  --border-color: #DCDFE6;
  --border-light: #E4E7ED;
  --border-lighter: #EBEEF5;
  --border-extra-light: #F2F6FC;
  --bg-color: #F5F7FA;
  --bg-white: #FFFFFF;
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
  --shadow-md: 0 2px 8px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 4px 16px rgba(0, 0, 0, 0.1);
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --transition-fast: all 0.2s ease;
  --transition-normal: all 0.3s ease;
}

html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: var(--text-primary);
  background-color: var(--bg-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  box-sizing: border-box;
}

a {
  color: var(--primary-color);
  text-decoration: none;
  transition: var(--transition-fast);
}

a:hover {
  color: var(--primary-light);
}

.el-button {
  border-radius: var(--radius-sm) !important;
  font-weight: 500;
  transition: var(--transition-fast);
  color: var(--text-regular) !important;
}

.el-button--primary {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  color: #fff !important;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background-color: var(--primary-light) !important;
  border-color: var(--primary-light) !important;
  color: #fff !important;
}

.el-button--primary:hover {
  background-color: var(--primary-light) !important;
  border-color: var(--primary-light) !important;
}

.el-button--primary:active {
  background-color: var(--primary-dark) !important;
  border-color: var(--primary-dark) !important;
}

.el-button--success {
  background-color: var(--success-color) !important;
  border-color: var(--success-color) !important;
  color: #fff !important;
}

.el-button--warning {
  background-color: var(--warning-color) !important;
  border-color: var(--warning-color) !important;
  color: #fff !important;
}

.el-button--danger {
  background-color: var(--danger-color) !important;
  border-color: var(--danger-color) !important;
  color: #fff !important;
}

.el-button--info {
  background-color: var(--info-color) !important;
  border-color: var(--info-color) !important;
  color: #fff !important;
}

.el-button--text {
  background: transparent !important;
  border: none !important;
  color: var(--primary-color) !important;
}

.el-button--text:hover {
  color: var(--primary-light) !important;
}

.el-card {
  border-radius: var(--radius-md) !important;
  border: 1px solid var(--border-lighter) !important;
  box-shadow: var(--shadow-sm) !important;
  transition: var(--transition-normal) !important;
}

.el-card:hover {
  box-shadow: var(--shadow-md) !important;
}

.el-input__inner {
  border-radius: var(--radius-sm) !important;
  transition: var(--transition-fast) !important;
}

.el-input__inner:focus {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1) !important;
}

.el-table {
  border-radius: var(--radius-md) !important;
  overflow: hidden;
}

.el-table th {
  background-color: #fafafa !important;
  color: var(--text-regular) !important;
  font-weight: 600 !important;
  font-size: 13px !important;
}

.el-table td {
  padding: 12px 0 !important;
}

.el-tag {
  border-radius: var(--radius-sm) !important;
  font-weight: 500;
}

.el-dialog {
  border-radius: var(--radius-lg) !important;
  overflow: hidden;
}

.el-dialog__header {
  padding: 20px 24px 16px !important;
  border-bottom: 1px solid var(--border-lighter);
  margin: 0 !important;
}

.el-dialog__title {
  font-weight: 600 !important;
  font-size: 16px !important;
  color: var(--text-primary) !important;
}

.el-dialog__body {
  padding: 24px !important;
}

.el-dialog__footer {
  padding: 16px 24px 20px !important;
  border-top: 1px solid var(--border-lighter);
}

.el-form-item__label {
  font-weight: 500 !important;
  color: var(--text-regular) !important;
}

.el-pagination {
  margin-top: 20px;
  padding: 10px 0;
  text-align: right;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #c0c4cc;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease;
}

.slide-right-enter-from {
  opacity: 0;
  transform: translateX(-20px);
}

.slide-right-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>
